import React from "react";
import { Button } from "@material-ui/core";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { messages } from "./GoToWaitingLobbyButton.messages";
import { RoutePath } from "../../Routes/RoutePath";

interface Props {
  meetingId?: string;
}

const GoToWaitingLobbyButton = (props: Props) => {
  const { meetingId } = props;
  const intl = useIntl();
  const history = useHistory();

  const redirectToWaitingLobby = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (meetingId !== undefined) {
      history.push({
        pathname: RoutePath.WAITING_LOBBY,
        search: `meetingId=${meetingId}`,
      });
    }
  };

  return (
    <Button
      size="small"
      color="primary"
      variant="contained"
      onClick={redirectToWaitingLobby}
    >
      {intl.formatMessage(messages.buttonLabel)}
    </Button>
  );
};

export default GoToWaitingLobbyButton;
